import React, { useState } from "react";
import { collection, addDoc, Timestamp } from "firebase/firestore";
import { db } from "../firebase";
import emailjs from "emailjs-com";
import { ToastContainer, toast } from "react-toastify";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { useSelector } from "react-redux";
import "../css/SharedForms.css";

const DISCORD_WEBHOOK =
  "https://discord.com/api/webhooks/1505967406059622441/AdEQVldd3e9SkMy1Hgoe3mkEYTwscx-c4pYN_Ao0LCxpf5OOqeEUuGVNRwweJ1Oz6xY4";

const INSTRUCTIONS = [
  "Our volunteer will deliver the sadqa box (Gallah) at your doorstep.",
  "Save our no. 7400231537 in your mobile phone to receive regular updates about our activities regarding utilization of funds.",
  "Our volunteer will come to your house once every month to collect the sadqa/alms money and will issue you a receipt.",
  "We accept Zakat, Fitrah, Fidaya, Khums (Sehme Sadaat), Kaffara, Qurbani and all kinds of donation.",
  "For queries, suggestions or assistance, feel free to contact us through WHATSAPP on the following number: 7738805577",
];

const SadqaBoxForm = () => {
  const currentTheme = useSelector((state) => state.theme.current);

  const [formData, setFormData] = useState({
    fullName: "",
    fatherName: "",
    fullAddress: "",
    emailAddress: "",
    contactNumber: "",
    whatsappNumber: "",
    agreed: false,
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.fullName.trim() || formData.fullName.trim().length < 2)
      newErrors.fullName = "Full name is required (min 2 characters)";
    if (!formData.fatherName.trim() || formData.fatherName.trim().length < 2)
      newErrors.fatherName = "Father name is required (min 2 characters)";
    if (!formData.fullAddress.trim() || formData.fullAddress.trim().length < 5)
      newErrors.fullAddress = "Full address is required (min 5 characters)";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.emailAddress))
      newErrors.emailAddress = "Valid email address is required";
    if (!/^\+?[\d\s-]{10,}$/.test(formData.contactNumber))
      newErrors.contactNumber = "Valid contact number is required (10+ digits)";
    if (!/^\+?[\d\s-]{10,}$/.test(formData.whatsappNumber))
      newErrors.whatsappNumber = "Valid WhatsApp number is required (10+ digits)";
    if (!formData.agreed)
      newErrors.agreed = "You must agree to the instructions to proceed";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) {
      toast.error("Please fill in all fields correctly", {
        position: "top-center",
        autoClose: 3000,
      });
      return;
    }

    setIsSubmitting(true);

    const body = `
SADQA BOX COLLECTION FORM
━━━━━━━━━━━━━━━━━━━━━━━━
Full Name: ${formData.fullName}
Father Name: ${formData.fatherName}
Full Address: ${formData.fullAddress}
Email Address: ${formData.emailAddress}
Contact Number: ${formData.contactNumber}
WhatsApp Number: ${formData.whatsappNumber}
Agreed to Instructions: Yes
Submitted At: ${new Date().toLocaleString()}
    `.trim();

    try {
      await addDoc(collection(db, "SadqaBoxRequests"), {
        date: Timestamp.now(),
        formType: "sadqa-box",
        status: "pending",
        fullName: formData.fullName,
        fatherName: formData.fatherName,
        fullAddress: formData.fullAddress,
        emailAddress: formData.emailAddress,
        contactNumber: formData.contactNumber,
        whatsappNumber: formData.whatsappNumber,
        agreed: true,
        details: body,
        bookedBy: "",
      });
    } catch (err) {
      console.error("Firestore error:", err);
    }

    try {
      await fetch(DISCORD_WEBHOOK, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          embeds: [
            {
              title: "📦 New Sadqa Box Collection Request",
              color: 0xf39c12,
              description: body.slice(0, 4000),
              timestamp: new Date(),
            },
          ],
        }),
      });
    } catch (err) {
      console.error("Discord error:", err);
    }

    emailjs
      .send(
        "service_y5g4vjs",
        "template_1ayop5o",
        {
          to_email: "alqaimwelfareinfo@gmail.com",
          from_name: "Al Qaim Welfare Foundation - Sadqa Box Form",
          subject: `Sadqa Box Request - ${formData.fullName} - ${formData.contactNumber}`,
          message: body,
        },
        "ivuz1YIJqTWXipbyc"
      )
      .then(() => {
        toast.success(
          "Your request has been submitted successfully! We will contact you soon.",
          { position: "top-center", autoClose: 4000 }
        );
        setFormData({
          fullName: "",
          fatherName: "",
          fullAddress: "",
          emailAddress: "",
          contactNumber: "",
          whatsappNumber: "",
          agreed: false,
        });
        setErrors({});
        setIsSubmitting(false);
      })
      .catch((err) => {
        console.error("EmailJS error:", err);
        toast.error("Failed to send. Please try again.", {
          position: "top-center",
          autoClose: 3000,
        });
        setIsSubmitting(false);
      });
  };

  return (
    <>
      <Navbar />
      <div className="sf-page">
        <div className="sf-hero" style={{ background: currentTheme }}>
          <div className="sf-hero-icon">📦</div>
          <h1 className="sf-hero-title">Collect Sadqah Box</h1>
          <p className="sf-hero-sub">
            Request a Sadqah box (Gallah) to be delivered to your doorstep
          </p>
        </div>

        <div className="sf-container">
          {/* Instructions Card */}
          <div className="sf-instructions-card">
            <h2 className="sf-instructions-title">
              <span className="sf-inst-icon">📋</span> Instructions
            </h2>
            <ul className="sf-instructions-list">
              {INSTRUCTIONS.map((inst, i) => (
                <li key={i} className="sf-instructions-item">
                  <span className="sf-inst-num">{i + 1}</span>
                  <span>{inst}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Form Card */}
          <div className="sf-form-card">
            <h2 className="sf-form-title">Fill in Your Details</h2>
            <form className="sf-form" onSubmit={handleSubmit} noValidate>
              <div className="sf-field">
                <label className="sf-label">
                  Full Name <span className="sf-required">*</span>
                </label>
                <input
                  type="text"
                  name="fullName"
                  className={`sf-input ${errors.fullName ? "sf-input-error" : ""}`}
                  placeholder="Enter your full name"
                  value={formData.fullName}
                  onChange={handleChange}
                />
                {errors.fullName && (
                  <span className="sf-err-msg">{errors.fullName}</span>
                )}
              </div>

              <div className="sf-field">
                <label className="sf-label">
                  Father's Name <span className="sf-required">*</span>
                </label>
                <input
                  type="text"
                  name="fatherName"
                  className={`sf-input ${errors.fatherName ? "sf-input-error" : ""}`}
                  placeholder="Enter your father's name"
                  value={formData.fatherName}
                  onChange={handleChange}
                />
                {errors.fatherName && (
                  <span className="sf-err-msg">{errors.fatherName}</span>
                )}
              </div>

              <div className="sf-field">
                <label className="sf-label">
                  Full Address <span className="sf-required">*</span>
                </label>
                <textarea
                  name="fullAddress"
                  className={`sf-textarea ${errors.fullAddress ? "sf-input-error" : ""}`}
                  placeholder="Enter your complete address (building, area, city, pincode)"
                  value={formData.fullAddress}
                  onChange={handleChange}
                  rows={3}
                />
                {errors.fullAddress && (
                  <span className="sf-err-msg">{errors.fullAddress}</span>
                )}
              </div>

              <div className="sf-field">
                <label className="sf-label">
                  Email Address <span className="sf-required">*</span>
                </label>
                <input
                  type="email"
                  name="emailAddress"
                  className={`sf-input ${errors.emailAddress ? "sf-input-error" : ""}`}
                  placeholder="Enter your email address"
                  value={formData.emailAddress}
                  onChange={handleChange}
                />
                {errors.emailAddress && (
                  <span className="sf-err-msg">{errors.emailAddress}</span>
                )}
              </div>

              <div className="sf-row">
                <div className="sf-field">
                  <label className="sf-label">
                    Contact Number <span className="sf-required">*</span>
                  </label>
                  <input
                    type="tel"
                    name="contactNumber"
                    className={`sf-input ${errors.contactNumber ? "sf-input-error" : ""}`}
                    placeholder="e.g. 9876543210"
                    value={formData.contactNumber}
                    onChange={handleChange}
                  />
                  {errors.contactNumber && (
                    <span className="sf-err-msg">{errors.contactNumber}</span>
                  )}
                </div>

                <div className="sf-field">
                  <label className="sf-label">
                    WhatsApp Number <span className="sf-required">*</span>
                  </label>
                  <input
                    type="tel"
                    name="whatsappNumber"
                    className={`sf-input ${errors.whatsappNumber ? "sf-input-error" : ""}`}
                    placeholder="e.g. 9876543210"
                    value={formData.whatsappNumber}
                    onChange={handleChange}
                  />
                  {errors.whatsappNumber && (
                    <span className="sf-err-msg">{errors.whatsappNumber}</span>
                  )}
                </div>
              </div>

              <div
                className={`sf-checkbox-card ${errors.agreed ? "sf-checkbox-error" : ""}`}
              >
                <label className="sf-checkbox-label">
                  <input
                    type="checkbox"
                    name="agreed"
                    className="sf-checkbox"
                    checked={formData.agreed}
                    onChange={handleChange}
                  />
                  <span className="sf-checkbox-text">
                    ✅ I agree to these Instructions — I have read and understood
                    all the instructions mentioned above and agree to the terms of
                    the Sadqah Box collection program.
                  </span>
                </label>
                {errors.agreed && (
                  <span className="sf-err-msg">{errors.agreed}</span>
                )}
              </div>

              <button
                type="submit"
                className="sf-submit-btn"
                style={{ background: currentTheme }}
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <>
                    <span className="sf-spinner"></span> Submitting...
                  </>
                ) : (
                  "Submit Request"
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
      <ToastContainer />
      <Footer />
    </>
  );
};

export default SadqaBoxForm;